import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SearchBar' })({
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    toolbar: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12
    },
    search: {
        padding: '12px 24px',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 12,
        whiteSpace: 'nowrap',
        background: '#232323 !important',
        color: '#fff'
    }
});
